module.exports = __webpack_public_path__ + "img/1570x1047.5145ed4d.png";